import React, { Component } from "react";
import lang from '../../lang';
import ListPannel from './list-pannel';
import Tooltip from 'rc-tooltip';
import { Link } from "react-router";
import List from "./list-pannel";
class HeadHistory extends Component {

	constructor(props) {
		super(props);
		this.state = {
			keyword: '',
			showSearchResult: false,
            counter: 0
		};

	}

    gitList= ()=>{
        let counter = this.state.counter;

        this.setState({
            counter: counter+1
        });
    }
	render() {
        let list=this.state.data;
        let $pop = (
                <div key={this.state.counter} className="s-result s-result-pop">
					<div className="s-result-scroller hostlist-lite" >
                        <ListPannel  showFollowInfo="true" ref="list"/>
					</div>
                </div>
        	);
            
        return (
            <Tooltip  key={1} getTooltipContainer={()=>this.refs.history} overlay={$pop} placement="bottom" trigger={['hover']} overlayClassName="header-popover header-history-popover">
                <div className="history btn-head" ref="history" onMouseEnter={this.gitList}>
                    <div className="result-pop-hd" ref='follow' >
                        <Link to="/history">{lang.template('观看历史')}</Link>
                    </div>
                </div>
            </Tooltip>
        );

	}
}

export default HeadHistory;



// WEBPACK FOOTER //
// ./js/header/history/index.js